import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "ffd_auth_token";

export const getToken = () => {
    try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
};
export const setToken = (token) => {
    try { localStorage.setItem(TOKEN_KEY, token); } catch { /* private mode */ }
};
export const clearToken = () => {
    try { localStorage.removeItem(TOKEN_KEY); } catch { /* private mode */ }
};

const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
    timeout: 60000,
    // We use Bearer tokens in localStorage instead of cookies. Keeping
    // `withCredentials: false` lets CORS-preflight succeed even when the
    // server (or an edge proxy like Cloudflare) responds with
    // `Access-Control-Allow-Origin: *` — that combo is forbidden when
    // credentials are sent, and is what broke production logins earlier.
    withCredentials: false,
});

// Attach the Bearer token from localStorage on every outgoing request.
// This is the PRIMARY auth path on deployments where the ingress forces
// Access-Control-Allow-Origin: * (which forbids cookies under the CORS spec).
api.interceptors.request.use((config) => {
    const token = getToken();
    if (token && !config.headers?.Authorization) {
        config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
    }
    return config;
});

// Auto-redirect to /login on 401 — handled inside AuthContext too, but this
// catches axios calls that bypass the context.
api.interceptors.response.use(
    (resp) => resp,
    (error) => {
        if (error?.response?.status === 401 && typeof window !== "undefined") {
            const path = window.location.pathname;
            const url = error?.config?.url || "";
            // Don't redirect when we ARE on /login or hitting /auth/* endpoints —
            // the Login page handles its own 401s.
            if (path !== "/login" && !url.includes("/auth/")) {
                clearToken();
                window.location.assign("/login");
            }
        }
        return Promise.reject(error);
    },
);

export default api;
